import { Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import '../../../Styles/ChecklistQuestions.css'
import { cn } from 'src/lib/utils'
import { useTranslation } from 'react-i18next'
import { Checkbox } from 'src/Common/ui/checkbox'
import { format, parseISO, setDate } from 'date-fns'

function UserChecklistQuestions ({ dueBy, editAccess, activeTab, setSubmitValid, setdata, inputValidation, control, data, errors, onInputChangeTextArea, onInputChange, handleAddControls, handleDeleteControls }) {
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const handleDueOn = (completedOn) => {
        // Step 1: Convert dueBy to a Date object
        const dueByDate = parseISO(dueBy)

        // Step 2: Replace the day with completedOn
        const updatedDate = setDate(dueByDate, completedOn)

        // Step 3: Format the new date
        const formattedDate = format(updatedDate, 'dd-MMM-yyyy')

        return {
            format: formattedDate,
            date: updatedDate
        } // Output: "04-Jun-2025"
    }
    const rowsPerPage = 5
    const totalPages = Math.ceil(data.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }

    const [ checklist, setChecklist ] = useState([])
    useEffect(() => {
        if (data.length > 0) {
            setChecklist(data)
        }
    }, [data])
    useEffect(() => {
        if (checklist.length > 0) {
            setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        }
    }, [ checklist, currentPage ])
    const { t } = useTranslation()
    const handleSelectCheckbox = (value, id) => {
        const change = checklist.map((item, i) => {
            if (item.id === id) {
                item.response = !item.response
                if (item.response) {
                    const date = new Date()
                    date.setUTCHours(0, 0, 0, 0)
                    item.checkListResponses[0].completedDate = date.toISOString()
                } else {
                    item.checkListResponses[0].completedDate = null
                }
            }
            return item
        })
        const find = change.every(item => {
            return item.response
        })
        if (find) {
            setSubmitValid(true)
        } else {
            setSubmitValid(false)
        }
        setChecklist(change)
        setdata(prevState => {
            return {
                ...prevState,
                checkLIst: change
            }
        })
        return value
    }
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    useEffect(() => {
        setEntries({
            entry: data?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    const dateComparison = (dueDate, completedDate, item) => {
        // const isLate = isAfter(completedDate, dueDate) // Compare
        return (
            <div style={{ color: 'hsl(var(--muted))' }}>
                {item?.response ? format(new Date(item.checkListResponses[0].completedDate), 'dd-MMM-yyyy') : '-'}
            </div>
        )
    }
    return (
        <>
            <div style={{ display: activeTab === 4 ? 'block' : 'none', height: '100%', flexDirection: 'column' }}>
                <div className='h-[80%]' >
                    <TableContainer className={cn('checklist-comp-table global-table')} style={{ flexGrow: 1 }}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {/* <TableCell sx={{ border: 'none' }} colSpan={3}></TableCell>
                                    <TableCell align='center' colSpan={2}>{t('Risk of non compliance limit')}</TableCell> */}
                                </TableRow>
                                <TableRow>
                                    <TableCell align='center'><p className={cn('')}>#</p></TableCell>
                                    <TableCell ><p className={cn('comp-table-th pl-2')}>{t('Actions')}</p></TableCell>
                                    <TableCell align='center'><p className={cn('comp-table-th pl-2')}>{t('Due on')}</p></TableCell>
                                    <TableCell align='center'><p className={cn('comp-table-th pl-2')}>{t('Completed On')}</p></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    paginatedData?.map((item, j) => {
                                        return (
                                            <>
                                                <TableRow>
                                                    <TableCell align='center'><div className='w-full flex justify-center'>
                                                        <Checkbox
                                                            disabled={editAccess}
                                                            checked={item.response}
                                                            onCheckedChange={(event) => handleSelectCheckbox(item, item.id)}
                                                            borderColor='text-primary'
                                                        />
                                                    </div></TableCell>
                                                    <TableCell >
                                                        <p className={'checklist-comp-table-td'}>
                                                            <div>{item?.actions}</div>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <p className={cn('text-[hsl(var(--muted))] font-semibold', 'checklist-comp-table-td')}>
                                                            <div>{handleDueOn(item?.taskOnDue)?.format}</div>
                                                        </p>
                                                    </TableCell>
                                                    <TableCell align='center'>
                                                        <p className={cn('text-[hsl(var(--Low))] font-semibold', 'checklist-comp-table-td')}>
                                                            <div>{dateComparison(handleDueOn(item?.taskOnDue).date, new Date(item.checkListResponses[0].completedDate), item)}</div>
                                                        </p>
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        )
                                    })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </div>
                {data.length > 0 && (
                    <div className="border-t-2 border-t-primary-foreground flex items-center justify-between p-4 h-[20%]" style={{ flexShrink: 0 }}>
                        <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded"
                        />
                    </div>
                )}
            </div>
        </>
    )
}

UserChecklistQuestions.propTypes = {
    setSubmitValid: PropTypes.any,
    setdata: PropTypes.any,
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onInputChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.any
}

export default UserChecklistQuestions
